var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDriversActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conductores_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 34,
    height: 34,
    transform: "translate(767 649)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27",
    "data-name": "Rect\\xE1ngulo 27",
    width: 28.122,
    height: 29.422,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_19",
    "data-name": "Enmascarar grupo 19",
    transform: "translate(-767 -649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(769.939 651.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M0,26.377c.074-.557.127-1.118.225-1.671A14,14,0,0,1,10.578,13.612c.065-.016.127-.041.216-.071A7.118,7.118,0,0,1,6.93,7.295,6.853,6.853,0,0,1,9.092,2.034,7.164,7.164,0,1,1,17.4,13.525c.6.2,1.216.36,1.8.6a13.784,13.784,0,0,1,8.786,10.955,8.009,8.009,0,0,1,.116,2.054,2.527,2.527,0,0,1-2.114,2.233.726.726,0,0,0-.128.052H21.317c-.061-.02-.121-.045-.184-.06A2.578,2.578,0,0,1,19.14,27.4c-.019-.07-.034-.142-.06-.247l-1.262.732c.187.933.117,1.13-.524,1.535h-.46a1.14,1.14,0,0,1-.668-.945,2.118,2.118,0,0,0-4.174-.011,1.108,1.108,0,0,1-.731.955h-.287c-.34-.118-.66-.292-.7-.68a7.032,7.032,0,0,1,.06-1.071L9.092,26.95c-.012.095-.018.16-.029.224a2.549,2.549,0,0,1-1.98,2.166c-.139.031-.279.055-.419.082H2.241c-.061-.02-.121-.045-.184-.06A2.469,2.469,0,0,1,.344,28.087,6.877,6.877,0,0,1,0,27.124v-.747m23.743,1.3c.063.007.091.013.119.013.517,0,1.034,0,1.551,0a.909.909,0,0,0,1-1.077,18.239,18.239,0,0,0-.4-2.574,12.332,12.332,0,0,0-13.158-9.078,12,12,0,0,0-7.738,3.8,12.005,12.005,0,0,0-3.379,7.956.867.867,0,0,0,.942.976c.488,0,.976,0,1.465,0,.091,0,.182-.009.266-.013V25.972c-.153,0-.286,0-.419,0a.875.875,0,0,1-.881-.872.863.863,0,0,1,.9-.849c.412,0,.824-.017,1.235.005a.492.492,0,0,0,.5-.271,9.881,9.881,0,0,1,10.092-4.4,9.782,9.782,0,0,1,6.629,4.474.372.372,0,0,0,.369.2c.45-.011.9-.009,1.35,0a.857.857,0,0,1,.868.85.87.87,0,0,1-.824.868c-.158.011-.318,0-.482,0ZM11.926,2.2A5.417,5.417,0,0,0,15.5,12.4a5.327,5.327,0,0,0,3.967-5.539A5.672,5.672,0,0,1,11.926,2.2m8.6,22.123a8.125,8.125,0,0,0-12.773-.146l1.737,1.007L11.247,26.2c.093-.086.169-.157.247-.227a3.853,3.853,0,0,1,5.342.172.3.3,0,0,0,.45.06c1.076-.638,2.163-1.259,3.243-1.884M13.617,1.774A3.865,3.865,0,0,0,15.6,4.941a3.784,3.784,0,0,0,3.491.19,5.334,5.334,0,0,0-5.472-3.357M6.169,25.987v1.677a.993.993,0,0,0,1.041-.344.856.856,0,0,0,.029-.949c-.239-.416-.637-.431-1.071-.384m15.823,0a.966.966,0,0,0-1.061.388.834.834,0,0,0,.044.965.917.917,0,0,0,1.018.305Z",
    transform: "translate(0 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriversActive);
export default __webpack_public_path__ + "static/media/icon_drivers_active.65cea1db68b72c16577b4efb083e6d08.svg";
export { ForwardRef as ReactComponent };